// src/theme/index.ts
import type { MantineThemeOverride } from "@mantine/core";

export const appTheme: MantineThemeOverride = {
  colors: {
    // brand must have exactly 10 items
    brand: [
      "#ffced8", // [0] lightest
      "#ff9db0", // [1] mid-lightest
      "#ff758f", // [2]
      "#f94c6e", // [3]
      "#ee374d", // [4] primary
      "#e82f49", // [5]
      "#dc2742", // [6]
      "#d01f3b", // [7]
      "#bc1b36", // [8]
      "#a72740", // [9] darkest
    ] as [
        string,
        string,
        string,
        string,
        string,
        string,
        string,
        string,
        string,
        string
      ],
    // optional extra colors must also have 10 items if used
    accent: [
      "#FFEBF0",
      "#FFC6D9",
      "#FF9EC3",
      "#FF77AD",
      "#FF4081",
      "#F50066",
      "#E1005A",
      "#C9004F",
      "#B20044",
      "#990038",
    ] as [
        string,
        string,
        string,
        string,
        string,
        string,
        string,
        string,
        string,
        string
      ],
  },
  primaryColor: "brand",
  primaryShade: 6,
  defaultRadius: "sm",
  fontFamily: "'Inter', sans-serif",


  components: {

    // Target each input type
    TextInput: {
      styles: (theme) => ({
        input: {
          borderRadius: theme.radius.md,
          borderColor: theme.colors.gray[3],
          '&:focus': {
            borderColor: theme.colors.brand[4],
          },
        },
      }),
    },
    Select: {
      styles: (theme) => ({
        input: {
          borderRadius: theme.radius.md,
        },
      }),
    },
    Textarea: {
      styles: (theme) => ({
        input: {
          borderRadius: theme.radius.md,
        },
      }),

    }
  }
};



